export default "https://cdn-static.gokick.com/assets/bae15fb1898ed89c0d72225e63ca082ea63e0d65/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";